import { render } from "./ModalChallenge.vue?vue&type=template&id=2df029df"
import script from "./ModalChallenge.vue?vue&type=script&lang=js"
export * from "./ModalChallenge.vue?vue&type=script&lang=js"
script.render = render

export default script